import React, { useEffect, useState } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { BsPerson } from "react-icons/bs";
import { BsEyeSlash } from "react-icons/bs";
import { BsEye } from "react-icons/bs";
import { HiOutlineQrCode } from "react-icons/hi2";
import { QRCodeSVG } from "qrcode.react";





import Blocked from '../Blocked/Blocked';

const SignInform = props => {
    const [passwordIsVisible, setPasswordIsVisible] = useState(false);
    const [showTwoFactorModal, setShowTwoFactorModal] = useState(false);

    useEffect(() => {
        setShowTwoFactorModal(Boolean(props.otpRequired));
    }, [props.otpRequired]);

    return (
        <Form onSubmit={props.loginHandler} render={({ handleSubmit, submitting, pristine, values }) => (
            <form onSubmit={!props.userIsBlocked ? handleSubmit : event => event.preventDefault()} autoComplete="false">
                <div id="loginForm">
                    <div className="form-group form-material floating" data-plugin="formMaterial">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><BsPerson size={17} /></span>
                            </div>
                            <div className="form-control-wrap">
                                <Field type="text" name="username" className="form-control empty" component="input" required />
                                <label className="floating-label">Username or email</label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-material floating" data-plugin="formMaterial">
                        <div className="input-group">
                            <div className="input-group-prepend" onClick={() => setPasswordIsVisible(!passwordIsVisible)} style={{ cursor: 'pointer' }}>
                                <span className="input-group-text">{!passwordIsVisible ? <BsEyeSlash size={16} /> : <BsEye size={16} />}</span>
                            </div>
                            <div className="form-control-wrap">
                                <Field type={!passwordIsVisible ? 'password' : 'text'} name="password" className="form-control empty" component="input" required />
                                <label className="floating-label">Password</label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-material floating" data-plugin="formMaterial">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><HiOutlineQrCode size={17}/></span>
                            </div>
                            <div className="form-control-wrap">
                                <Field type="text" name="code" className="form-control empty" component="input" required />
                                <label className="floating-label">Code</label>
                            </div>
                        </div>
                    </div>
                    {showTwoFactorModal && props.otpRequired && (
                        <div
                            role="dialog"
                            aria-modal="true"
                            aria-labelledby="two-factor-setup-title"
                            style={{
                                position: 'fixed',
                                inset: 0,
                                zIndex: 1050,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '20px',
                                backgroundColor: 'rgba(0, 0, 0, 0.65)',
                            }}
                        >
                            <div
                                style={{
                                    width: '100%',
                                    maxWidth: '420px',
                                    padding: '28px',
                                    textAlign: 'center',
                                    backgroundColor: '#fff',
                                    borderRadius: '6px',
                                    color: '#333',
                                }}
                            >
                                <h4 id="two-factor-setup-title">Set up two-factor authentication</h4>
                                {props.otpauthUri ? (
                                    <>
                                        <p>Scan this QR code with Google Authenticator.</p>
                                        <QRCodeSVG
                                            value={props.otpauthUri}
                                            size={220}
                                            includeMargin
                                        />
                                    </>
                                ) : (
                                    <p>
                                        Enter the six-digit code from Google Authenticator.
                                    </p>
                                )}
                                <div className="form-group form-material floating" style={{ marginTop: '20px' }}>
                                    <div className="form-control-wrap">
                                        <Field
                                            type="text"
                                            name="otp"
                                            className="form-control empty"
                                            component="input"
                                            inputMode="numeric"
                                            pattern="[0-9]{6}"
                                            minLength="6"
                                            maxLength="6"
                                            autoComplete="one-time-code"
                                            required
                                        />
                                        <label className="floating-label">Six-digit OTP</label>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-block btn-success"
                                    disabled={submitting}
                                >
                                    Verify and sign in
                                </button>
                            </div>
                        </div>
                    )}
                    <div className="form-group clearfix">
                        <div className="checkbox-custom checkbox-inline checkbox-primary float-left">
                            <input type="checkbox" id="remember" name="checkbox" />
                            <label htmlFor="remember">Remember me</label>
                        </div>
                        <a className="float-right" href='/forgot-password'>Forgot password?</a>
                    </div>
                </div>
                <div className="form-group">
                    {props.userIsBlocked && <Blocked />}
                    {!props.userIsBlocked && (
                        <button type="submit" className="btn btn-block btn-sm btn-raised btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic" disabled={submitting || pristine}>
                            <span><i className="icon ti-unlock" aria-hidden="true"></i>&nbsp;Sign In</span>
                        </button>
                    )}
                </div>
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </form>
        )} />
    );
};

const mapStateToProps = state => {
    return {
        userIsBlocked: state.auth.userIsBlocked
    };
};

SignInform.propTypes = {
    loginHandler: propTypes.func,
    otpRequired: propTypes.bool,
    otpauthUri: propTypes.string,
    userIsBlocked: propTypes.bool
};

export default connect(mapStateToProps)(SignInform);
